var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"role":"button"},on:{"click":function($event){return _vm.onClick($event)}}},[_c('span',{staticClass:"no-selection"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }